import { Maximize2 } from 'lucide-react'
import * as React from 'react'

import { Dialog, DialogContent, DialogTrigger } from './dialog'

interface ExpanderProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  image: string
  alt: string
  isHighlightImage?: boolean
}

const Expander = Dialog

const ExpanderTrigger = React.forwardRef<
  React.ElementRef<typeof DialogTrigger>,
  React.ComponentPropsWithoutRef<typeof DialogTrigger> & ExpanderProps
>(({ image, alt, className, isHighlightImage = false, ...props }, ref) => (
  <div className={`${className}`}>
    <DialogTrigger
      ref={ref}
      className={`group relative h-full w-full`}
      {...props}
    >
      {isHighlightImage ? (
        <div className="relative col-span-2 row-span-2">
          <img
            src={image}
            alt="Photo highlight from property"
            className="aspect-square h-full w-full rounded-lg object-cover"
          />
          <span className="absolute left-1/2 top-2 w-11/12 -translate-x-1/2 text-nowrap rounded-full bg-white py-1 text-center text-sm text-monochromatic-400 2xl:w-4/5">
            Foto destaque
          </span>
        </div>
      ) : (
        <img
          className="h-full w-full select-none rounded-lg object-cover hover:border-2 hover:border-bios-primary"
          src={image}
          alt={alt}
        />
      )}
      <Maximize2 className="pointer-events-none absolute left-1/2 top-1/2 size-6 -translate-x-1/2 -translate-y-1/2 rounded-lg bg-gray-400/40 p-1 text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100 md:size-8 lg:size-10" />
    </DialogTrigger>
  </div>
))
ExpanderTrigger.displayName = DialogTrigger.displayName

const ExpanderContent = React.forwardRef<
  React.ElementRef<typeof DialogContent>,
  React.ComponentPropsWithoutRef<typeof DialogContent> & ExpanderProps
>(({ image, alt, className, ...props }, ref) => (
  <DialogContent
    ref={ref}
    className={`h-auto w-[90vw] lg:h-3/4 lg:min-h-[90vh] ${className}`}
    {...props}
  >
    <img
      className="mt-6 aspect-auto h-full w-full select-none object-contain lg:mt-0"
      src={image}
      alt={alt}
    />
  </DialogContent>
))
ExpanderContent.displayName = DialogContent.displayName

export { Expander, ExpanderTrigger, ExpanderContent }
